import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { NotiflowVersion } from "@/types/entities";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

type PublishVersionsResponse = {
  version: NotiflowVersion;
};

export const usePublishNotiflowVersions = (
  projectId: string,
  notiflowId: string,
  options: Omit<
    UseMutationOptions<NotiflowVersion, UnprocessableEntityError, void, unknown>,
    "mutationFn"
  > = {},
) => {
  const queryClient = useQueryClient();

  return useMutation<NotiflowVersion, UnprocessableEntityError, void, unknown>({
    mutationFn: async (): Promise<NotiflowVersion> => {
      const response = await api.post<PublishVersionsResponse>(
        `/projects/${projectId}/notiflows/${notiflowId}/versions/publish`
      );
      return camelize(response.data.version);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows", notiflowId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows", notiflowId, "versions"],
      });
    },
    ...options
  });
};
